import { PageConstant } from "../../constants";

const mobileV2Pages = [
    PageConstant.VETSMITH_PAGE,
    'specialized-vetting',
];

export const getMobilePageVersion = (path) => {
    return mobileV2Pages.some(page => path.includes(page)) ? 'v2' : 'v1';
};
